export default "__VITE_ASSET__DjCzDyaS__"